import { render, staticRenderFns } from "./ImportFileBatch.vue?vue&type=template&id=573c0dfc&scoped=true&"
import script from "./ImportFileBatch.vue?vue&type=script&lang=js&"
export * from "./ImportFileBatch.vue?vue&type=script&lang=js&"
import style0 from "./ImportFileBatch.vue?vue&type=style&index=0&id=573c0dfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573c0dfc",
  null
  
)

export default component.exports